<template>
    <div id="avatar-component">
        <picture>
            <source :srcset="$url + 'img/bg_avatar.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_avatar.png'" type="image/png"> 
            <img id="bg" :src="$url + 'img/bg_avatar.webp'">
        </picture>
        <picture>
            <source :srcset="$url + 'img/bg_verde_header.webp'" type="image/webp">
            <source :srcset="$url + 'img/bg_verde_header.png'" type="image/png"> 
            <img id="bg-header" :src="$url + 'img/bg_verde_header.webp'">
        </picture>
        <div id="avatares">
            <h3>Avatar</h3>
            <h4>Selecione seu avatar abaixo:</h4>
            <ul>
                <li id="avatar_1" v-on:click="avatarHandler(1)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_1.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_1.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_1.webp'">
                        </picture>
                    </a>
                </li>
                <li id="avatar_2" v-on:click="avatarHandler(2)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_2.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_2.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_2.webp'">
                        </picture>
                    </a>
                </li>
                <li id="avatar_3" v-on:click="avatarHandler(3)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_3.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_3.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_3.webp'">
                        </picture>
                    </a>
                </li>
                <li id="avatar_4" v-on:click="avatarHandler(4)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_4.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_4.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_4.webp'">
                        </picture>
                    </a>
                </li>
                <li id="avatar_5" v-on:click="avatarHandler(5)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_5.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_5.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_5.webp'">
                        </picture>
                    </a>
                </li>
                <li id="avatar_6" v-on:click="avatarHandler(6)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_6.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_6.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_6.webp'">
                        </picture>
                    </a>
                </li>
                <li id="avatar_7" v-on:click="avatarHandler(7)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_7.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_7.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_7.webp'">
                        </picture>
                    </a>
                </li>
                <li id="avatar_8" v-on:click="avatarHandler(8)">
                    <span><img :src="$url + 'img/check_bt.png'"></span>
                    <a href="#">
                        <picture>
                            <source :srcset="$url + 'img/avatar/avatar_8.webp'" type="image/webp">
                            <source :srcset="$url + 'img/avatar/avatar_8.png'" type="image/png"> 
                            <img :src="$url + 'img/avatar/avatar_8.webp'">
                        </picture>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import axios from 'axios';
    export default {
        name: "AvatarComponent",
        data() {
            return {
                actual: null
            }
        },
        computed: {
            ...mapGetters(['token', 'logged', 'id', 'name', 'email', 'points', 'started', 'player', 'avatar'])
        },
        methods: {
            ...mapActions(['update_avatar']),
            avatarHandler(n) {
                event.preventDefault();
                
                let user = { token: this.token, id: this.id, email: this.email, name: this.name, points: this.points, avatar:n };
                this.$parent.saveUser(user);

                event.currentTarget.classList.toggle("avatar_active");
                if (this.actual)
                    this.actual.classList.toggle("avatar_active");
                this.actual = event.currentTarget;
                this.update_avatar(n);

                let form_data = new FormData();
                form_data.append('avatar', n);
                axios.put(this.$b + 'api/users/' + this.id + '?' + new URLSearchParams(form_data).toString()).then(response => this.avatarHandlerResponse(response));
            },
            avatarHandlerResponse(obj) {
                obj;
                this.$router.push('/jogo');
                //this.$parent.focusGame();
            }
        },
        mounted() {
            document.getElementsByTagName('header')[0].style.borderBottom = 'solid 1px #e5e5e5';
            document.getElementsByClassName('menu-icon')[0].getElementsByTagName('ul')[0].getElementsByTagName('li')[1].style.color = '#1e6337';
            document.getElementById("logo").style.filter = 'none';
            this.actual = document.getElementById('avatar_' + this.avatar);
            this.actual.classList.toggle("avatar_active");
        }
    }
</script>

<style scoped>
    #bg
    {
        bottom: 0;
        height: 872px;
        left: calc(50% - 960px);
        position: fixed;
        width: 1920px;
        z-index: 0;
    }
    #bg-header
    {
        left: calc(50% - 960px);
        position: fixed;
        top: 80px;
        width: 1920px;
    }
    h3
    {
        color: #1e6337;
        font-family: 'Paper Cutout';
        font-size: 50px;
        font-weight: normal;
        text-align: center;
    }
    h4
    {
        color: #999;
        font-family: 'Roboto';
        font-size: 18px;
        text-align: center;
    }
    #avatares
    {
        box-sizing: border-box;
        display: block;
        margin: 0 auto;
        padding-top: 120px;
        position: relative;
        width: 1000px;
        z-index: 6;
    }
    #avatares > ul > li
    {
        display: inline-block;
        vertical-align: top;
    }
    #avatares > ul > li > a
    {
        border: solid 5px #e5e5e5;
        border-radius: 30px;
        box-sizing: border-box;
        display: block;
        height: 240px;
        margin: 10px 10px 0 0;
        padding: 30px;
        width: 240px;
    }
    #avatares > ul > li > a:hover
    {
        background-image: url("../assets/img/estrelas_avatar.png");
        background-repeat: no-repeat;
        background-position: center;
        border: solid 5px #a0b327;
    }
    #avatares > ul > li:hover > span
    {
        background-color: #a0b327;
    }
    #avatares > ul > li:hover > span > img
    {
        filter: brightness(0) invert(1);
    }
    .avatar_active > span
    {
        background-color: #a0b327 !important;
        
    }
    .avatar_active > span > img
    {
        filter: brightness(0) invert(1);
    }
    .avatar_active > a
    {
        background-image: url("../assets/img/estrelas_avatar.png");
        background-repeat: no-repeat;
        background-position: center;
        border: solid 5px #a0b327 !important;
    }
    #avatares > ul > li > a > picture > img
    {
        display: block;
        margin: 0 auto;
    }
    #avatares > ul > li > span
    {
        background-color: #f5f5f5;
        border-radius: 50%;
        box-sizing: border-box;
        height: 44px;
        line-height: 47px;
        margin-left: 185px;
        margin-top: 20px;
        padding: 5px;
        position: absolute;
        width: 44px;
    }

    .btn-00 {
        display: block;
        margin: 40px auto;
        width: 200px;
    }

    @media screen and (max-width: 980px)
    {
        #avatares
        {
            width: 100%;
        }
        #avatares > ul > li, #avatares > ul > li > a
        {
            width: calc(100% - 20px);
        }
        #avatares > ul > li > a
        {
           margin: 20px;
        }
        #avatares > ul > li > span
        {
            margin: 35px 15px 0 0;
            float: right;
            position: relative;
        }
    }
</style>
